<template>
  <DeviceDeliveryDetail :is-edit="true"/>
</template>

<script>
import DeviceDeliveryDetail from './detail';

export default {
  name: "DeviceDeliveryEdit",
  components: { DeviceDeliveryDetail },
}
</script>

<style scoped>

</style>
